var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { randomInteger } from '../../../utils/helper/helper_math';
export class CycleReward {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get cycle() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    get doesCycleHaveAReward() {
        if (this.app.menubar.menubarRight.isMultiPlayerMode)
            return false;
        if (!this.rewardAnswer)
            return false;
        return true;
    }
    get randomRewardIndex() {
        return randomInteger(0, 9);
    }
    get rewardAnswer() {
        const miniRewards = this.app.tray.funnel.funnelReward.remainingMiniRewardsSortedByPriority;
        if (miniRewards.length === 0)
            return undefined;
        if (miniRewards.length < 10)
            return this.app.tray.trayTransform.funnelMiniQuestionToAnswer(miniRewards[0]);
        return this.app.tray.trayTransform.funnelMiniQuestionToAnswer(miniRewards[this.randomRewardIndex]);
    }
}
__decorate([
    memoize
], CycleReward.prototype, "randomRewardIndex", null);
__decorate([
    computed
], CycleReward.prototype, "rewardAnswer", null);
